export const SNACKBAR_SUCCESS = 'SUCCESS';
export const SNACKBAR_UPDATE_USERS_ROLE_FAIL = 'UPDATE_USERS_ROLE_FAIL';
export const SNACKBAR_GET_ROLES_FAIL = 'GET_ROLES_FAIL';
export const SNACKBAR_USERS_GET_PROFILE_BY_ID_ERROR = 'USERS_GET_PROFILE_BY_ID_ERROR';
export const SNACKBAR_USERS_ID_OR_PASSWORD_ERROR = 'Invalid user ID and/or password';
export const SNACKBAR_EDIT_PASSWORD_SUCCESS = 'EDIT_PASSWORD_SUCCESS';
export const SNACKBAR_EDIT_PASSWORD_ERROR = 'EDIT_PASSWORD_ERROR';
